import Requisicao from "./RequisicaoService";

class MenuService {
    static async listar(admin) {
        return Requisicao.get('menu/' + admin);
    }    
}

export default MenuService;